import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { MenuProvider } from './context/MenuContext';
import { GlobalStyles } from './styles/GlobalStyles';
import { theme } from './styles/theme';

// Pages
import AdminDashboard from './pages/AdminDashboard';
import CounterBilling from './pages/CounterBilling';
import CustomerManagement from './pages/CustomerManagement';
import FinancialManagement from './pages/FinancialManagement';
import InventoryManagement from './pages/InventoryManagement';
import KitchenDisplay from './pages/KitchenDisplay';
import Login from './pages/Login';
import MenuManagement from './pages/MenuManagement';
import OrdersManagement from './pages/OrdersManagement';
import PromotionsManagement from './pages/PromotionsManagement';
import Reports from './pages/Reports';
import SalesData from './pages/SalesData';
import Settings from './pages/Settings';
import StaffManagement from './pages/StaffManagement';
import TablesManagement from './pages/TablesManagement';
import WaiterOrdering from './pages/WaiterOrdering';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <MenuProvider>
        <Router>
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/login" element={<Login />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/admin/orders" element={<OrdersManagement />} />
            <Route path="/admin/menu" element={<MenuManagement />} />
            <Route path="/admin/inventory" element={<InventoryManagement />} />
            <Route path="/admin/tables" element={<TablesManagement />} />
            <Route path="/admin/customers" element={<CustomerManagement />} />
            <Route path="/admin/financial" element={<FinancialManagement />} />
            <Route path="/admin/promotions" element={<PromotionsManagement />} />
            <Route path="/admin/reports" element={<Reports />} />
            <Route path="/admin/staff" element={<StaffManagement />} />
            <Route path="/admin/settings" element={<Settings />} />
            <Route path="/admin/sales" element={<SalesData />} />
            <Route path="/waiter/ordering" element={<WaiterOrdering />} />
            <Route path="/counter/billing" element={<CounterBilling />} />
            <Route path="/kitchen/display" element={<KitchenDisplay />} />
          </Routes>
        </Router>
      </MenuProvider>
    </ThemeProvider>
  );
}

export default App;
